import classnames from "classnames";
import styles from "./Heading.module.scss";
import {HeadingProps} from "./Heading.props.ts";

export const Heading = ({children, className, as}: HeadingProps) => {
  const Component = as;
  return <Component className={classnames(className, styles[as])}>{children}</Component>;
};
